import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {createStructuredSelector} from 'reselect'
import PropTypes from 'prop-types'
import { toggleChat, closeChat, resetChat, openChat } from 'widget/store/actions'
import selectors from '../../store/selectors'
import WidgetLayout from './layout'
import { newUserMessage } from 'App/actions'
import createFocusTrap from 'focus-trap'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'
import { openExternalWindow } from './externalWindow'
import { getUrlParameterByName } from '../../../helpers/index'
import { getAppInstanceId } from '../../../helpers/getAppInstanceId'

class Widget extends Component {
  focusTrapBot = null
  state = {
    isMinimized: false,
    showBot: null
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showChat !== nextProps.showChat) {
      window.postMessage({ type:'botOpen', value: nextProps.showChat }, '*')
    }

    if (nextProps.showChat) {
      this.toggleFocusTrap(true)
    }
  }

  toggleConversation = () => {
    const { config, showChat, onStartConversation, dispatch } = this.props
    if (config.windowed) {
      // When opened in a new window, the window does not have access to the parent window's localStorage, so we have to pass the user_email and app_instance_id as query params and store them in storage in the new window.
      const user_email = localStorage.getItem('user_email')
      const app_instance_id = getAppInstanceId()
      const call_session_id = sessionStorage.getItem('call_session_id')
      return openExternalWindow({ ...config, user_email, app_instance_id, call_session_id})
    }
    this.toggleFocusTrap(!showChat)
    onStartConversation(config)
    dispatch(toggleChat())
    this.setState({
      isMinimized: true
    })
    localStorage.setItem('botOpenedByUser', '1')
  };

  closeConversation = () => {
    this.toggleFocusTrap(false)
    this.props.dispatch(closeChat())
    this.props.dispatch(resetChat())
    this.props.onCloseConversation()
    this.setState({
      isMinimized: false
    })

    localStorage.removeItem('botOpenedByUser')
  };
  

  componentDidMount() {
    const { embedded, autoOpen } = this.props.config
    const botShouldAutoOpen = autoOpen && localStorage.getItem('botOpenedByUser')

    if (embedded || botShouldAutoOpen) {
      this.toggleConversation()
    }

    this.registerDeepLinking(true)
  }

  componentDidUpdate(_prevProps, prevState) {
    this.initFocusTrap()

    if (this.state.showBot !== prevState.showBot) {
      this.handleDeepLinking()
    }
  }

  componentWillUnmount() {
    this.registerDeepLinking(false)
  }

  registerDeepLinking = (shouldRegister) => {
    const setShowBot = () => {
      this.setState({ showBot: getUrlParameterByName('showBot')})
    }
    if (shouldRegister) {
      if (!this.state.showBot) {
        setShowBot()
      }
      document.addEventListener('historyChanged', setShowBot)
    } else {
      document.removeEventListener('historyChanged', setShowBot)
    }
  }

  handleDeepLinking = () => {
    const { showBot } = this.state
    
    if (showBot) {
      this.props.dispatch(newUserMessage({
        // Don't send showBot value to api when it's 'true' string,
        // otherwise it will be module name
        text: ' ', module: showBot === 'true' ? null : showBot
      }))
      return this.props.dispatch(openChat()) 
    }
  }  

  initFocusTrap = () => {
    if (this.focusTrapBot) return

    var botContainer = document.getElementById('db-chat-widget-root')

    this.focusTrapBot = createFocusTrap('#db-chat-widget-root', {
      clickOutsideDeactivates: true,
      allowOutsideClick: (event) => {
        if (event.target !== botContainer) {
          return true
        }
      }
    })
  }

  toggleFocusTrap = (activate) => {
    //disable focus trap for full screen view.
    if (window.innerWidth < FULLSCEEN_WIDTH_BREAKPOINT) return
    if (!this.focusTrapBot) return

    if (activate) {
      try {
        return this.focusTrapBot.activate()
      } catch (e) {
        console.error(e)
      }
    }

    return this.focusTrapBot.deactivate()
  }

  render() {
    return (
      <WidgetLayout
        onToggleConversation={this.toggleConversation}
        onCloseConversation={this.closeConversation}
        title={this.props.title}
        subtitle={this.props.subtitle}
        senderPlaceHolder={this.props.senderPlaceHolder}
        avatarBot={this.props.avatarBot}
        avatarUser={this.props.avatarUser}
        fullScreenMode={this.props.fullScreenMode}
        badge={this.props.badge}
        launcher={this.props.launcher}
        config={this.props.config}
        minimized={this.state.isMinimized}
      />
    )
  }
}

Widget.propTypes = {
  avatarBot: PropTypes.string,
  avatarUser: PropTypes.string,
  launcher: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  senderPlaceHolder: PropTypes.string,
  fullScreenMode: PropTypes.bool,
  isFetching: PropTypes.bool,
  badge: PropTypes.number,
  config: PropTypes.shape({
    apiKey: PropTypes.string,
    backend: PropTypes.string.isRequired,
    botId: PropTypes.string.isRequired,
    avatarBot: PropTypes.string,
    avatarUser: PropTypes.string,
    liveAgentAvatar: PropTypes.string,
    launcher: PropTypes.shape({
      icon: PropTypes.string,
      minimizedIcon: PropTypes.string,
      height: PropTypes.number,
    }),
    title: PropTypes.string
  }),
  onStartConversation: PropTypes.func.isRequired,
  onCloseConversation: PropTypes.func,
}


Widget.defaultProps = {
  title: 'Welcome',
  subtitle: null,
  senderPlaceHolder: 'Type a message or select an option.',
  'aria-label': 'Type a message',
  fullScreenMode: false,
  badge: 0,
  typing: false,
  onCloseConversation: _.noop(),
}


const mapStateToProps = createStructuredSelector({
  showChat: selectors.selectShowChat,
  isFetching: selectors.selectIsFetching,
  senderPlaceHolder: selectors.selectSenderPlaceholder
})

export default connect(mapStateToProps)(Widget)



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Widget/index.js